import { Observable } from 'rxjs'
import { OrgModel } from '../models/org-model'

export abstract class GetAllOrgGateway {
    abstract getOrgDetail(): Observable<OrgModel[]>
}
